import List from 'react-virtualized/dist/commonjs/List';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import { compose } from 'redux';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isEqual, map, find, findIndex } from 'lodash';
import { DropTarget as dropTarget } from 'react-dnd';
import uuid from 'uuid/v4';
import {
  OVER_SCAN_ROW_COUNT,
} from './GeoMapConstant';
import {
  GEOGRAPHICS_GRID_HEADER_LABELS, SORT_DIRECTION,
} from '../../util/geomapUtils';
import GeoMapCellContent from './GeoMapCellContent';
import deleteIcon from '../../images/geomap_trash.png';

const target = {
  drop(props) {
    const { row } = props;
    return ({
      row,
    });
  },
};

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  highlighted: monitor.canDrop(),
});

class GeomapGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      selectedSpIds: [],
      selectedBaseRowIndex: -1,
      selectedLastRowIndex: -1,
      shiftSelectedRows: [],
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.handleScrollBarWidth();
    }, 2000);
    window.addEventListener('resize', this.handleScrollBarWidth);
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      !isEqual(this.props.selectedTabGeographyData, nextProps.selectedTabGeographyData)
    ) {
      this.setState({ selectedRows: [], selectedSpIds: [] });
    }
    setTimeout(() => {
      this.handleScrollBarWidth();
    }, 2000);
  }

  componentDidUpdate() {
    this.handleScrollBarWidth();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleScrollBarWidth);
  }

  handleScrollBarWidth = () => {
    $.fn.getScrollWidth = () => {
      const $outer = $('<div>').css({ visibility: 'hidden', width: 100, overflow: 'scroll' }).appendTo('body');
      const widthWithScroll = $('<div>').css({ width: '100%' }).appendTo($outer).outerWidth();
      $outer.remove();
      return 100 - widthWithScroll;
    };
    $.fn.hasVScrollBar = () => {
      if ($('.after-scroll-header-col').length !== 0) {
        $('.after-scroll-header-col').remove();
      }

      return $('.ReactVirtualized__List').get(0)
        ? $('.ReactVirtualized__List').get(0).scrollHeight >
            $('.ReactVirtualized__List').height()
        : false;
    };
    const hasScrollBar = $('.ReactVirtualized__List').hasVScrollBar();
    if (hasScrollBar) {
      const scrollWidth = $().getScrollWidth();
      if ($('.after-scroll-header-col').length === 0) {
        $('.geo-grid-header').append(
          `<div class="after-scroll-header-col" style="min-width:${scrollWidth}px;
          width:${scrollWidth}px;background-color:#${'2f445c'}"></div>`
        );
      }
    } else if ($('.after-scroll-header-col').length !== 0) {
      $('.after-scroll-header-col').remove();
    }
  };

  rowSelectionRange = (rowPid, geographyData) => {
    const { selectedBaseRowIndex,
      selectedLastRowIndex, shiftSelectedRows, selectedRows } = this.state;
    const finalNodes = [];
    const recentlySelected = [];
    let finalSelectedRows = [];
    let selectedRowsRange = [];
    let spIdsRange = [];
    map(selectedRows, elemPid => {
      if (shiftSelectedRows.findIndex(elPid => elemPid === elPid) === -1) {
        finalNodes.push(elemPid);
      }
    });
    if (selectedBaseRowIndex <= selectedLastRowIndex) {
      selectedRowsRange = geographyData.slice(
        selectedBaseRowIndex,
        selectedLastRowIndex + 1,
      );
      map(selectedRowsRange, elPid => {
        if (finalNodes.findIndex(elePid => elePid === elPid) === -1) {
          recentlySelected.push(elPid);
        }
      });
      finalSelectedRows = [...finalNodes, ...recentlySelected];
    } else {
      selectedRowsRange = geographyData.slice(
        selectedLastRowIndex,
        selectedBaseRowIndex + 1,
      );
      map(selectedRowsRange, elPid => {
        if (finalNodes.findIndex(elePid => elePid === elPid) === -1) {
          recentlySelected.push(elPid);
        }
      });
      finalSelectedRows = [...finalNodes, ...recentlySelected];
    }
    if (this.props.selectedTab === 'county' || this.props.selectedTab === 'zipcode') {
      spIdsRange = map(finalSelectedRows, el => {
        const tempRow = find(this.props.selectedTabGeographyData, elem => elem.pid === el);
        return tempRow.sp;
      });
    }
    this.setState({
      shiftSelectedRows: [...selectedRowsRange],
      selectedRows: [...finalSelectedRows],
      selectedSpIds: [...spIdsRange],
    });
  }

  handleMouseUp = (e, rowPid, geographyData, spId) => {
    if (e.button === 0) {
      const { selectedBaseRowIndex, selectedLastRowIndex, selectedRows,
        selectedSpIds } = this.state;
      let baseNode = selectedBaseRowIndex;
      let lastNode = selectedLastRowIndex;
      if (
        e.shiftKey &&
        selectedRows.length !== 0 &&
        selectedRows[0] !== rowPid
      ) {
        const currentSelectedRowIndex = geographyData.indexOf(rowPid);
        if (baseNode >= 0) {
          lastNode = currentSelectedRowIndex;
        } else {
          baseNode = currentSelectedRowIndex;
          lastNode = currentSelectedRowIndex;
        }
        this.setState({
          selectedLastRowIndex: lastNode,
          selectedBaseRowIndex: baseNode,
        }, () => this.rowSelectionRange(rowPid, geographyData));
      } else if (selectedRows.indexOf(rowPid) !== -1) {
        const tempSPIds = [...selectedSpIds];
        if (this.props.selectedTab === 'county' || this.props.selectedTab === 'zipcode') {
          const index = findIndex(selectedSpIds, el => isEqual(el, spId));
          tempSPIds.splice(index, 1);
        }
        this.setState({
          selectedRows: selectedRows.filter(
            item => item !== rowPid,
          ),
          selectedSpIds: tempSPIds,
          selectedBaseRowIndex: -1,
          selectedLastRowIndex: -1,
          shiftSelectedRows: [],
        });
      } else {
        const selectedBaseRowIndex = geographyData.indexOf(rowPid);
        this.setState({
          selectedRows: [...selectedRows, rowPid],
          selectedBaseRowIndex,
          selectedLastRowIndex: selectedBaseRowIndex,
          shiftSelectedRows: [],
        }, () => this.rowSelectionRange(rowPid, geographyData));
      }
    }
  }

  deleteRows = () => {
    const { selectedRows, selectedSpIds } = this.state;
    this.props.deleteRows(selectedRows, selectedSpIds);
    this.setState({ selectedRows: [], selectedSpIds: [] });
  }

  onGeoMapGridViewSort = (key, columnIndex) => {
    let sortOrder = SORT_DIRECTION.DESC;
    if (
      this.props.sortColumnIndex === columnIndex &&
      this.props.sortKey === key
    ) {
      switch (this.props.sortOrder) {
        case SORT_DIRECTION.DESC:
          sortOrder = SORT_DIRECTION.ASC;
          break;
        case SORT_DIRECTION.ASC:
          sortOrder = SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = SORT_DIRECTION.DESC;
      }
    }
    this.props.onSort(sortOrder, key, columnIndex);
  };

  renderRow = index => {
    return (
      <GeoMapCellContent
        data-test="geomapCellContentComponent"
        geographyData={this.props.selectedTabGeographyData}
        handleMouseUp={this.handleMouseUp}
        selectedRows={this.state.selectedRows}
        index={index.index}
        key={index.key}
        style={index.style}
        selectedTab={this.props.selectedTab}
        getGeoTitle={this.props.getGeoTitle}
      />
    );
  }

  render() {
    const tableHeader = GEOGRAPHICS_GRID_HEADER_LABELS;
    const { connectDropTarget, selectedTabGeographyData,
      sortColumnIndex, sortKey, sortOrder } = this.props;
    const rowHeight = 28;
    return connectDropTarget(
      <div className="geo-grid">
        <div className="geo-grid-header">
          {tableHeader.map((item, columnIndex) => (
            <div
              key={uuid()}
              className={
                columnIndex === 0
                  ? 'geo-grid-header-item-0'
                  : columnIndex === 5
                  ? 'geo-grid-header-item-5'
                  : 'geo-grid-header-item'
              }
            >
              {columnIndex !== 5 && (
                <button
                  type="button"
                  id={`${item.key}-header${columnIndex}`}
                  onClick={() =>
                    selectedTabGeographyData &&
                    selectedTabGeographyData.length > 0
                      ? this.onGeoMapGridViewSort(item.key, columnIndex)
                      : null
                  }
                  style={{ textAlign: 'left' }}
                  className="geo-grid-header-item-value geo-grid-sort-item-all"
                >
                  {item.text}
                  {sortKey === item.key &&
                    sortOrder === 'desc' &&
                    sortColumnIndex === columnIndex && <span> ▼</span>}
                  {sortKey === item.key &&
                    sortOrder === 'asc' &&
                    sortColumnIndex === columnIndex && <span> ▲</span>}
                </button>
              )}
              {columnIndex === 5 && (
                <Fragment>
                  <button
                    type="button"
                    id={`${item.key}-header${columnIndex}`}
                    onClick={() =>
                      selectedTabGeographyData &&
                      selectedTabGeographyData.length > 0
                        ? this.onGeoMapGridViewSort(item.key, columnIndex)
                        : null
                    }
                    style={
                      this.state.selectedRows.length > 0
                        ? { textAlign: 'left', width: '70%' }
                        : { textAlign: 'left', width: '100%' }
                    }
                    className="geo-grid-header-item-value geo-grid-sort-item-5"
                  >
                    {item.text}
                    {sortKey === item.key &&
                      sortOrder === 'desc' &&
                      sortColumnIndex === columnIndex && <span> ▼</span>}
                    {sortKey === item.key &&
                      sortOrder === 'asc' &&
                      sortColumnIndex === columnIndex && <span> ▲</span>}
                  </button>
                  <button
                    type="button"
                    className="geo-grid-header-delete-rows geo-grid-header-item-value"
                    onClick={this.deleteRows}
                    style={
                      this.state.selectedRows.length > 0
                        ? { display: 'inline-block', width: '30%' }
                        : { display: 'none' }
                    }
                  >
                    <img src={deleteIcon} alt="delete" />
                  </button>
                </Fragment>
              )}
            </div>
          ))}
        </div>
        <div id="main-content-grid" className="geo-grid-content">
          {selectedTabGeographyData && selectedTabGeographyData.length === 0 && (
            <div className="blankImageBlockText" data-test="geomapEmptyGrid">
              Drag geographies into the table
            </div>
          )}
          {selectedTabGeographyData && selectedTabGeographyData.length > 0 && (
            <AutoSizer className="data-test-list">
              {({ width, height }) => (
                <List
                  width={width}
                  height={height}
                  rowHeight={rowHeight}
                  rowRenderer={this.renderRow}
                  rowCount={selectedTabGeographyData.length}
                  overscanRowCount={OVER_SCAN_ROW_COUNT}
                  selectedTabGeographyData={selectedTabGeographyData}
                  selectedRows={this.state.selectedRows}
                />
              )}
            </AutoSizer>
          )}
        </div>
      </div>
    );
  }
}

GeomapGrid.propTypes = {
  selectedTabGeographyData: PropTypes.instanceOf(Array),
  connectDropTarget: PropTypes.func,
  deleteRows: PropTypes.func,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  sortColumnIndex: PropTypes.number,
  onSort: PropTypes.func,
  selectedTab: PropTypes.string,
  getGeoTitle: PropTypes.func,
};

const enhance = compose(
  dropTarget('CATEGORY', target, collect),
);

export default enhance(GeomapGrid);
